(function(){
  var mega=document.getElementById('mega'),link=document.getElementById('colLink'),li=link&&link.parentNode,t;
  function open(){if(!mega)return;clearTimeout(t);mega.hidden=false;link.setAttribute('aria-expanded','true');}
  function close(){if(!mega)return;mega.hidden=true;link.setAttribute('aria-expanded','false');}
  function later(){clearTimeout(t);t=setTimeout(close,180);}
  if(mega&&li){
    li.addEventListener('mouseenter',open);li.addEventListener('mouseleave',later);
    mega.addEventListener('mouseenter',open);mega.addEventListener('mouseleave',later);
    link.addEventListener('focus',open);
    document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});
    link.addEventListener('click',function(e){
      if(window.matchMedia('(hover:none)').matches&&mega.hidden){e.preventDefault();open();}
    });
    document.addEventListener('click',function(e){if(!mega.contains(e.target)&&!li.contains(e.target))close();});
  }
  /* contact links: pre-filled message where the channel supports it (product name + link on product pages) */
  (function(){
    var n='/pages/contact',pre=true,hid=true,c=[],txt='Hi Dubai Wall ARTS, I have a question.';
    /* shared by shop.js and helper.js; in "hidden" mode the number only exists as char codes and is joined at click time */
    window.dwaWaUrl=function(t){
      var base=hid?'/whatsapp':n;
      return t&&pre?base+'?text='+encodeURIComponent(t):base;
    };
    if(location.pathname.indexOf('/products/')===0){
      var h=document.querySelector('main h1');
      if(h)txt='Hi Dubai Wall ARTS, I am interested in '+h.textContent.trim()+': '+location.href.split('?')[0];
    }
    [].forEach.call(document.querySelectorAll('a[data-wa]'),function(a){
      if(hid){var go=function(){a.href=window.dwaWaUrl(txt);};['pointerdown','click','focus','touchstart'].forEach(function(ev){a.addEventListener(ev,go,{passive:true});});}
      else a.href=window.dwaWaUrl(txt);
    });
  })();
  var mb=document.getElementById('menuBtn'),mn=document.getElementById('mobnav');
  if(mb&&mn)mb.addEventListener('click',function(){var o=mn.hidden;mn.hidden=!o;mb.setAttribute('aria-expanded',String(o));});
})();
